export default class Common {
    constructor() {

    }

    /**
     * ラジオボタンまたはチェックボックスかつチェック済みの場合値を返す
     * @param $elem
     * @returns {boolean}
     */
    static getFormValues($elem) {
        let type = $elem.attr("type");
        let result = false;

        switch (type) {
            case "checkbox":
            case "radio":
                if ($elem.prop("checked")) {
                    result = $elem.val();
                }
                break;
            default:
                result = $elem.val();
                break;
        }

        return result;
    }

    /**
     * フォーム項目に値の挿入またはチェックのオンを行う
     * @param $elem
     * @param value
     */
    static insertFormValues($elem, value) {
        switch ($elem.attr("type")) {
            case "checkbox":
            case "radio":
                // ラジオボタン・checkboxは配列で受け取るので
                $.each(value, (index, val) => {
                    if (val === $elem.val()) {
                        $elem.prop("checked", true);
                        return false;
                    }
                });
                break;
            default:
                $elem.val(value);
                break;
        }
    }

    static jumpBlock(target) {
        let prize = $(target);
        let position = prize.offset().top;

        $("body,html").animate({scrollTop: position}, "fast", "swing");
        return false;
    }
}
